import { Box, Drawer, useTheme } from "@mui/material"
import { tokens } from "../../../theme";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import CloseOverlayBtn from "../buttons/CloseOverlayBtn";


const SHModalBottom = (props) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [contentTheme, setContentTheme] = useState(document.querySelector('meta[name="theme-color"]').getAttribute("content"));
    const showClose = props.showClose ?? true;
    // When centered, the modal fits its content and sits in the middle of the
    // screen, growing symmetrically until the top reaches a 20vh offset and then
    // expanding downward, instead of always filling 80vh from the bottom.
    const centered = props.centered ?? false;

    useEffect(() => {

      setContentTheme(document.querySelector('meta[name="theme-color"]').getAttribute("content"));
      return () => {
      }
    },[])
    //Executed when value of one of the array vars change
    useEffect(() => {
      if(props.open) {
        document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#101013" : "#606D85"}`);
        document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#101013" : "#606D85"}`);
      } else {
        if (contentTheme === "#181820" || contentTheme === "#ecf0f5") {
          document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
          document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
        } else {
          document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#0F0F12": "#606D85"}`);
          document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#0F0F12": "#606D85"}`);
        }
      }

      return () => {
      }
  },[theme.palette.mode,props.open])

    return (
        <Drawer
          className={props.className ?? null}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          anchor="bottom"
          open={props.open}
          onClose={props.onClose}
          onKeyDown={props.onKeyDown || undefined}
          slotProps={{
            backdrop: {
              timeout: 300,
            },
          }}
          sx={{
            transition:"300ms",
            "& .MuiBackdrop-root" : {
                backdropFilter:"blur(4px)",
                background:`${theme.palette.mode === "dark" ? "rgba(14,14,17,.85)" : "rgba(46,65,95,.75)"} !important`,
            },
            ...(centered ? {
              "& .MuiDrawer-paper": {
                  background: "transparent",
                  boxShadow: "none",
                  overflow: "visible",
                  width: "100%",
                  maxWidth: "100%",
                  margin: 0,
                  height: "100vh",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
              },
            } : {
              "& .MuiDrawer-paper": {
                  background: "transparent",
                  boxShadow: "none",
                  overflow: "visible",
                  maxWidth: props.maxWidth ?? 1024,
                  margin: "0 auto",
                  height: "80vh",
                  left: 0,
                  right: 0,
                  bottom: 0,
              },
              "@media screen and (max-height: 800px)" : {
                "& .MuiDrawer-paper": {
                  height: "90vh",
                },
              },
              "@media screen and (max-height: 700px)" : {
                "& .MuiDrawer-paper": {
                  minHeight:"unset",
                  maxHeight:"unset",
                  height:'auto',
                  top:0,
                  bottom:0,
                },
              }
            }),
          }}
        >
           {centered ? (
             <Box sx={{ height: 1, display: "flex", flexDirection: "column", alignItems: "center", px: 2, boxSizing: "border-box" }}>
                {/* Top spacer: centers the modal but never lets it climb above a 20vh offset */}
                <Box sx={{ flex: "1 1 0", minHeight: "20vh", width: 1 }} />

                <Box component={motion.div} layout transition={{ layout: { duration: 0.45, ease: [0.32, 0.72, 0, 1] } }} sx={{ position: "relative", width: 1, maxWidth: props.maxWidth ?? 1024, mx: "auto", display: "flex", flexDirection: "column", minHeight: 0 }}>
                  {props.open && showClose ?
                    <Box onClick={props.onClose}>
                      <CloseOverlayBtn theme="close-overlay"></CloseOverlayBtn>
                    </Box>:
                  null}

                  <Box className="sh-modal-body" component={motion.div} layout transition={{ layout: { duration: 0.45, ease: [0.32, 0.72, 0, 1] } }} sx={{
                    position:"relative",
                    outlineColor: "transparent !important",
                    background:`${colors.bg["tertiary"]}`,
                    borderRadius: "24px",
                    maxHeight: "80vh",
                    overflow: "hidden",
                    display:'flex',
                    flexDirection:"column",
                    minHeight: 0,
                    ...props.sx?.body,
                  }}>
                    {props.children}
                  </Box>
                </Box>

                {/* Bottom spacer: only this side shrinks once the top hits its 20vh cap */}
                <Box sx={{ flex: "1 1 0", width: 1 }} />
             </Box>
           ) : (
             <Box sx={{ height: 1 }}>
                {props.open && showClose ?
                  <Box onClick={props.onClose}>
                    <CloseOverlayBtn theme="close-overlay"></CloseOverlayBtn>
                  </Box>:
                null}

                <Box className="sh-modal-body" sx={{
                  position:"relative",
                  outlineColor: "transparent !important",
                  background:`${colors.bg["tertiary"]}`,
                  borderTopLeftRadius: 24,
                  borderTopRightRadius: 24,
                  height: "100%",
                  overflow: "auto",
                  display:'flex',
                    minHeight: "80vh",
                  flexDirection:"column",
                  "@media screen and (max-height: 800px)" : {
                    minHeight: "90vh",

                  },
                  "@media screen and (max-height: 700px)" : {
                    minHeight:"unset",

                  },
                  ...props.sx?.body,
                }}>
                  {props.children}
                </Box>
             </Box>
           )}
       </Drawer>
    )
}

export default SHModalBottom;
